import {
    PUBLIC_FABRIC_GAME_LIST,
    PUBLIC_FABRIC_RETENTION,
    PUBLIC_FABRIC_LOS_MODULES,
    PUBLIC_FABRIC_CONTENT_BLOCKS,
    PUBLIC_FABRIC_LOS_RETENTION,
    PUBLIC_FABRIC_REGISTRATION_POC,
    PUBLIC_FABRIC_PLAYER_SERVICES,
    PUBLIC_FABRIC_PLAYOK_SETTINGS,
    PUBLIC_FABRIC_VERIFICATIONS,
    PUBLIC_FABRIC_SETTINGS_TAB,
    PUBLIC_FABRIC_PAYMENTS,
    PUBLIC_FABRIC_REGISTRATION
} from '$env/static/public';
import type { TMFEName } from './types';

export const MFE_NAMES = {
    FABRIC_GAME_LIST: 'fabric-game-list',
    FABRIC_LOS_MODULES: 'fabric-los-modules',
    FABRIC_CONTENT_BLOCKS: 'fabric-content-blocks',
    FABRIC_RETENTION: 'fabric-retention',
    FABRIC_LOS_RETENTION: 'fabric-los-retention',
    FABRIC_REGISTRATION: 'fabric-registration',
    FABRIC_REGISTRATION_POC: 'fabric-registration-poc',
    FABRIC_PAYMENTS: 'fabric-payments',
    FABRIC_PLAYER_SERVICES: 'fabric-player-services',
    FABRIC_VERIFICATIONS: 'fabric-verifications',
    FABRIC_SETTINGS_TAB: 'fabric-settings-tab',
    FABRIC_PLAYOK_SETTINGS: 'fabric-playok-settings',
    DEFAULT: 'fabric-los-modules'
} as const;

export const MFE_LOCATIONS = {
    [MFE_NAMES.FABRIC_GAME_LIST]: PUBLIC_FABRIC_GAME_LIST,
    [MFE_NAMES.FABRIC_LOS_MODULES]: PUBLIC_FABRIC_LOS_MODULES,
    [MFE_NAMES.FABRIC_CONTENT_BLOCKS]: PUBLIC_FABRIC_CONTENT_BLOCKS,
    [MFE_NAMES.FABRIC_RETENTION]: PUBLIC_FABRIC_RETENTION,
    [MFE_NAMES.FABRIC_LOS_RETENTION]: PUBLIC_FABRIC_LOS_RETENTION,
    [MFE_NAMES.FABRIC_REGISTRATION]: PUBLIC_FABRIC_REGISTRATION,
    [MFE_NAMES.FABRIC_REGISTRATION_POC]: PUBLIC_FABRIC_REGISTRATION_POC,
    [MFE_NAMES.FABRIC_PAYMENTS]: PUBLIC_FABRIC_PAYMENTS,
    [MFE_NAMES.FABRIC_PLAYER_SERVICES]: PUBLIC_FABRIC_PLAYER_SERVICES,
    [MFE_NAMES.FABRIC_VERIFICATIONS]: PUBLIC_FABRIC_VERIFICATIONS,
    [MFE_NAMES.FABRIC_SETTINGS_TAB]: PUBLIC_FABRIC_SETTINGS_TAB,
    [MFE_NAMES.FABRIC_PLAYOK_SETTINGS]: PUBLIC_FABRIC_PLAYOK_SETTINGS,
    DEFAULT: PUBLIC_FABRIC_LOS_MODULES
} as Record<TMFEName, string>;

export const LEGACY_MFES = [
    MFE_NAMES.FABRIC_GAME_LIST,
    MFE_NAMES.FABRIC_RETENTION,
    MFE_NAMES.FABRIC_REGISTRATION,
    MFE_NAMES.FABRIC_PLAYER_SERVICES,
    MFE_NAMES.FABRIC_VERIFICATIONS,
    MFE_NAMES.FABRIC_SETTINGS_TAB,
    MFE_NAMES.FABRIC_PLAYOK_SETTINGS,
    MFE_NAMES.FABRIC_PAYMENTS
] as TMFEName[];

export const LEGACY_MODULE_MFES = [MFE_NAMES.FABRIC_REGISTRATION_POC] as TMFEName[];

export const MFE_TEAM_NAMES = {
    Play: 'Play',
    Experience: 'Experience',
    Elevate: 'Elevate',
    Protect: 'Protect'
} as const;

export const MFE_TEAM = {
    [MFE_NAMES.FABRIC_GAME_LIST]: MFE_TEAM_NAMES.Play,
    [MFE_NAMES.FABRIC_LOS_MODULES]: MFE_TEAM_NAMES.Experience,
    [MFE_NAMES.FABRIC_CONTENT_BLOCKS]: MFE_TEAM_NAMES.Elevate,
    [MFE_NAMES.FABRIC_RETENTION]: MFE_TEAM_NAMES.Experience,
    [MFE_NAMES.FABRIC_LOS_RETENTION]: MFE_TEAM_NAMES.Experience,
    [MFE_NAMES.FABRIC_REGISTRATION]: MFE_TEAM_NAMES.Experience,
    [MFE_NAMES.FABRIC_PLAYER_SERVICES]: MFE_TEAM_NAMES.Protect,
    [MFE_NAMES.FABRIC_VERIFICATIONS]: MFE_TEAM_NAMES.Protect,
    [MFE_NAMES.FABRIC_PLAYOK_SETTINGS]: MFE_TEAM_NAMES.Protect,
    [MFE_NAMES.FABRIC_REGISTRATION_POC]: MFE_TEAM_NAMES.Experience,
    [MFE_NAMES.FABRIC_SETTINGS_TAB]: MFE_TEAM_NAMES.Experience,
    [MFE_NAMES.FABRIC_PAYMENTS]: MFE_TEAM_NAMES.Play
} as Record<TMFEName | string, (typeof MFE_TEAM_NAMES)[keyof typeof MFE_TEAM_NAMES]>;

export const MFE_MODULE_NAMES = {
    WYSIWYG_MODULE_NAME: 'ModuleWYSIWYG',
    IN_GAME_ADVENTURE_WIDGET: 'in-game-adventure-widget',
    IN_GAME_WALLET_BALANCE: 'wallet-balance-in-game',
    FEEDBACK: 'feedback',
    BOTTOM_FIXED_DRAWER: 'bottom-fixed-drawer',
    NATIVE_BRIDGE: 'native-bridge',
    IN_GAME_RIDABODO_WIDGET: 'in-game-ridabodo-widget',
    RIDABODO_INVITE_POP_UP: 'ridabodo-invite-pop-up',
    RIDABODO_EVENT_POP_UP: 'ridabodo-event-pop-up',
    IN_GAME_JACKPOT_BAR: 'in-game-jackpot-bar',
    IN_GAME_AVATAR_WIDGET: 'in-game-avatar-widget',
    REGISTRATION: 'registration',
    GAME_INFO: 'info',
    NOTIFICATIONS: 'notifications',
    MANDATORY_MESSAGES: 'mandatory-messages',
    SWEDISH_LOGIN_LIMITS: 'swedish-login-limits',
    LIVECHAT: 'livechat',
    MKODO: 'mkodo',
    IN_GAME_RECENT_VALUABLE: 'in-game-recent-valuable',
    LIKES_COUNTER: 'likes-counter',
    GAME_LAUNCH_HANDLER: 'game-launch-handler',
    LAUNCHER: 'launcher',
    BEFORE_LOGOUT_MODAL: 'before-logout-modal',
    SESSION_CONFIGURATION: 'session-configuration',
    RG_BAR: 'rg-bar',
    GAME_INFO_BAR: 'game-info-bar',
    LAST_2_ROUTES_LISTENER: 'last-2-routes-listener',
    SEON_SESSION: 'seon-session',
    GAMEPLAY_RG_BAR: 'gameplay-rg-bar',
    LEGAL_DOCUMENTS: 'legal-documents',
    SOWI: 'sowi'
} as const;
